<template>
  <div
    :class="{'colorized': isColorized, 'has-image': hasImage }" 
    class="ec-answer ec-word">
    <span 
      v-show="effectedWarningEnabled" 
      :aria-label="this.$t('answers.change_warning_msg')"
      class="ec-answer-effected-warning-edge hint--bottom-left hint--medium">
      <i 
        class="fa fa-exclamation" 
        aria-hidden="true" />
    </span>
    <div class="ec-answer-main">
      <div 
        class="ec-answer-text" 
        v-html="answer.answer"/>
      <div class="ec-answer-input ec-input-word">
        <input 
          :disabled="$store.readOnly"
          v-model="value"
          value="">
      </div>
    </div>
    <div 
      v-if="hasImage" 
      class="ec-answer-image" 
      @click="showImage">
      <div class="ec-answer-img-wrapper">
        <div class="ec-answer-img-overlay">
          <div class="ec-img-overlay-icon"><i 
            aria-hidden="true" 
            class="fa fa-search"/></div>
        </div> 
        <img :src="imageSrc" >
      </div>
    </div>
    <AnswerDebug 
      v-if="answer.additional_informations" 
      :debug-info="answer.additional_informations"
    />
  </div>
</template>
<script>
    import Answer from './Answer.vue'

    export default {
      name: "WordAnser",
      extends: Answer,
      computed: {
          aboveZero() {
              return this.value.length > 1
          },
      }
    }
</script>